<div class="notification-log-container">
  <div class="filters-bar">
    <div class="filter-group">
      <label>Event Type:</label>
      <kendo-dropdownlist
        [data]="eventTypes"
        [(ngModel)]="selectedEventType"
        [valuePrimitive]="true"
        [defaultItem]="'All Events'"
        (valueChange)="onFilterChange()"
      ></kendo-dropdownlist>
    </div>

    <div class="filter-group">
      <label>Status:</label>
      <kendo-dropdownlist
        [data]="statusOptions"
        [(ngModel)]="selectedStatus"
        [valuePrimitive]="true"
        [defaultItem]="'All Statuses'"
        (valueChange)="onFilterChange()"
      ></kendo-dropdownlist>
    </div>

    <button kendoButton fillMode="flat" (click)="clearFilters()">
      <span class="k-icon k-font-icon k-i-filter-clear"></span> Clear Filters
    </button>

    <button kendoButton fillMode="flat" (click)="loadLogs()">
      <span class="k-icon k-font-icon k-i-reload"></span> Refresh
    </button>
  </div>

  <kendo-grid
    [data]="{ data: logs, total: totalCount }"
    [loading]="loading"
    [pageSize]="pageSize"
    [skip]="skip"
    [pageable]="true"
    (pageChange)="onPageChange($event)"
    class="logs-grid"
  >
    <kendo-grid-column field="sentAt" title="Sent At" [width]="170">
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ formatDate(dataItem.sentAt) }}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="eventType" title="Event Type" [width]="160"></kendo-grid-column>
    <kendo-grid-column field="subject" title="Subject"></kendo-grid-column>
    <kendo-grid-column field="status" title="Status" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span class="status-badge" [ngClass]="getStatusClass(dataItem.status)">
          {{ dataItem.status }}
        </span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="relatedEntityType" title="Entity" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem>
        <span *ngIf="dataItem.relatedEntityType">
          {{ dataItem.relatedEntityType }} #{{ dataItem.relatedEntityId }}
        </span>
        <span *ngIf="!dataItem.relatedEntityType" class="no-entity">-</span>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="" [width]="80">
      <ng-template kendoGridCellTemplate let-dataItem>
        <button kendoButton size="small" fillMode="flat" (click)="viewDetails(dataItem)">
          <span class="k-icon k-font-icon k-i-eye"></span>
        </button>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>

<!-- Details Dialog -->
<kendo-dialog
  *ngIf="showDetailsDialog && selectedLog"
  title="Notification Details"
  (close)="closeDetailsDialog()"
  [width]="600"
>
  <div class="details-content">
    <div class="detail-row">
      <label>Sent At:</label>
      <span>{{ formatDate(selectedLog.sentAt) }}</span>
    </div>

    <div class="detail-row">
      <label>Event Type:</label>
      <span>{{ selectedLog.eventType }}</span>
    </div>

    <div class="detail-row">
      <label>Subject:</label>
      <span>{{ selectedLog.subject }}</span>
    </div>

    <div class="detail-row">
      <label>Status:</label>
      <span class="status-badge" [ngClass]="getStatusClass(selectedLog.status)">
        {{ selectedLog.status }}
      </span>
    </div>

    <div class="detail-row" *ngIf="selectedLog.relatedEntityType">
      <label>Related Entity:</label>
      <span>{{ selectedLog.relatedEntityType }} #{{ selectedLog.relatedEntityId }}</span>
    </div>

    <div class="detail-row recipients-row">
      <label>Recipients:</label>
      <div class="recipients-list">
        <span *ngFor="let recipient of parseRecipients(selectedLog.recipients)" class="recipient-badge">
          {{ recipient }}
        </span>
      </div>
    </div>

    <div class="detail-row" *ngIf="selectedLog.errorMessage">
      <label>Error Message:</label>
      <div class="error-message">{{ selectedLog.errorMessage }}</div>
    </div>
  </div>
  <kendo-dialog-actions>
    <button kendoButton (click)="closeDetailsDialog()">Close</button>
  </kendo-dialog-actions>
</kendo-dialog>
